import React, { useState } from "react";
import { X, Tag, Check } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useAppContext } from "../context/AppContext";

interface QrOrderModalProps {
  setShowQrModal: (v: boolean) => void;
  activePetId: string;
  activePet: any;
  ownerName: string;
  ownerPhone: string;
}

export default function QrOrderModal({
  setShowQrModal,
  activePetId,
  activePet,
  ownerName,
  ownerPhone,
}: QrOrderModalProps) {
  const { user, lang } = useAppContext();
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [deliveryData, setDeliveryData] = useState("");

  const handleOrderTag = async () => {
    if (!user || !deliveryData.trim())
      return alert(
        lang === "uk" ? "Заповніть дані доставки!" : "Fill in delivery info!"
      );
    await addDoc(collection(db, "tag_orders"), {
      userId: user.uid,
      petId: activePetId,
      petName: activePet.name,
      ownerName: ownerName || "Не вказано",
      ownerPhone: ownerPhone || "Не вказано",
      deliveryData,
      status: "new",
      createdAt: serverTimestamp(),
    });
    alert(
      lang === "uk"
        ? "Замовлення успішно прийнято!"
        : "Order placed successfully!"
    );
    setShowOrderForm(false);
    setShowQrModal(false);
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 z-[300] flex flex-col justify-center items-center backdrop-blur-sm animate-fade-in p-4"
      onClick={() => setShowQrModal(false)}
    >
      <div
        className="bg-[var(--bg-card)] rounded-[2.5rem] p-6 w-full max-w-sm border border-[var(--border-color)] relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setShowQrModal(false)}
          className="absolute top-4 right-4 text-[var(--text-main)] p-2 bg-[var(--bg-soft)] rounded-full active:scale-95"
        >
          <X size={20} />
        </button>
        <h3 className="font-black text-2xl text-[var(--text-main)] text-center mb-1">
          {activePet.name}
        </h3>
        <p className="text-sm text-[var(--text-muted)] text-center mb-6">
          Ваш унікальний ID:{" "}
          <span className="font-mono font-bold text-[var(--text-main)]">
            {activePetId}
          </span>
        </p>

        <div className="bg-white p-4 rounded-3xl mx-auto w-fit border-4 border-[var(--bg-soft)] shadow-lg mb-8">
          <QRCodeSVG
            value={`${window.location.origin}/?scan=${activePetId}`}
            size={180}
            fgColor="#2d1f45"
          />
        </div>

        {!showOrderForm ? (
          <button
            onClick={() => setShowOrderForm(true)}
            className="w-full py-4 bg-[#2d1f45] text-white font-bold rounded-xl flex justify-center items-center gap-2 active:scale-95 shadow-xl text-sm"
          >
            <Tag size={20} /> Замовити фірмовий брелок
          </button>
        ) : (
          <div className="animate-fade-in flex flex-col gap-3">
            <p className="text-xs font-bold text-[#a073e7] uppercase mb-1">
              Оформлення замовлення
            </p>
            <textarea
              value={deliveryData}
              onChange={(e) => setDeliveryData(e.target.value)}
              placeholder="Місто, номер відділення Нової Пошти, ПІБ отримувача..."
              className="w-full p-4 bg-[var(--bg-soft)] border border-[var(--border-color)] text-[var(--text-main)] rounded-xl outline-none text-sm min-h-[100px]"
            />
            <button
              onClick={handleOrderTag}
              className="w-full py-4 bg-[#10b981] text-white font-bold rounded-xl flex justify-center items-center gap-2 active:scale-95 shadow-md text-sm"
            >
              <Check size={20} /> Підтвердити замовлення
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
